module.exports = __webpack_public_path__ + "img/6-1.be3b8d42.png";